/**
 * Custom Hero – section JS
 *
 * Bootstrapped from the liquid file via:
 *   customHeroInit('CustomHero-SECTION_ID');
 */
(function () {
  window.customHeroInit = function (heroId) {
    var hero = document.getElementById(heroId);
    if (!hero) return;

    /* ── Load animation ── */
    if (hero.dataset.animate === 'true') {
      function triggerAnim() {
        void hero.offsetHeight;
        setTimeout(function () {
          hero.classList.add('custom-hero--loaded');
        }, 50);
      }
      var rect = hero.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) {
        triggerAnim();
      } else {
        var obs = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { triggerAnim(); obs.disconnect(); }
          });
        }, { threshold: 0.1 });
        obs.observe(hero);
      }
    }

    /* ── Lookbook: apply positions based on viewport ── */
    var TABLET_BP = 991;
    function isMobile() { return window.innerWidth <= TABLET_BP; }

    /* ── Focal point: swap object-position for desktop vs mobile images ── */
    function applyFocalPoints() {
      var mobile = isMobile();
      hero.querySelectorAll('.custom-hero__slide-image').forEach(function (img) {
        var focal = mobile
          ? (img.dataset.mobileFocal || img.dataset.desktopFocal || 'center center')
          : (img.dataset.desktopFocal || 'center center');
        img.style.objectPosition = focal;
      });
    }

    function applyMarkerPositions() {
      var mobile = isMobile();
      var xKey = mobile ? 'mobileX' : 'desktopX';
      var yKey = mobile ? 'mobileY' : 'desktopY';

      hero.querySelectorAll('.custom-hero__dot').forEach(function (dot) {
        var x = dot.dataset[xKey];
        var y = dot.dataset[yKey];
        if (x !== undefined) dot.style.left = x + '%';
        if (y !== undefined) dot.style.top = y + '%';
      });

      hero.querySelectorAll('.custom-hero__card').forEach(function (card) {
        var x = card.dataset[xKey];
        var y = card.dataset[yKey];
        if (x !== undefined) card.style.left = x + '%';
        if (y !== undefined) card.style.top = y + '%';
      });
    }

    /* ── Lookbook: clamp cards on mobile so they stay in-slide ── */
    function clampMobileCards() {
      if (!isMobile()) return;
      hero.querySelectorAll('.swiper-slide').forEach(function (slide) {
        var slideW = slide.offsetWidth;
        var slideH = slide.offsetHeight;
        if (!slideW || !slideH) return;

        slide.querySelectorAll('.custom-hero__card').forEach(function (card) {
          var cardW = card.offsetWidth;
          var cardH = card.offsetHeight;
          if (!cardW || !cardH) return;

          var leftPx = parseFloat(card.style.left) / 100 * slideW;
          var topPx = parseFloat(card.style.top) / 100 * slideH;
          var pad = 6;
          var clampedLeft = Math.max(pad, Math.min(leftPx, slideW - cardW - pad));
          var clampedTop = Math.max(pad, Math.min(topPx, slideH - cardH - pad));

          card.style.left = (clampedLeft / slideW * 100) + '%';
          card.style.top = (clampedTop / slideH * 100) + '%';
        });
      });
    }

    /* ==========================================================================
       Draw SVG connection lines (dot → card)
       ========================================================================== */
    function drawConnections() {
      hero.querySelectorAll('.swiper-slide').forEach(function (slide) {
        var svg = slide.querySelector('.custom-hero__svg');
        if (!svg) return;

        svg.querySelectorAll('line, path').forEach(function (l) { l.remove(); });

        var slideRect = slide.getBoundingClientRect();
        var VW = slideRect.width || 1097;
        var VH = slideRect.height || 701;
        svg.setAttribute('viewBox', '0 0 ' + VW + ' ' + VH);

        var dots = slide.querySelectorAll('.custom-hero__dot');
        var cards = slide.querySelectorAll('.custom-hero__card');

        cards.forEach(function (card) {
          var mi = parseInt(card.dataset.markerIndex, 10);
          var dot = dots[mi];
          if (!dot) return;

          var isHideMobile = dot.classList.contains('custom-hero__dot--hide-mobile');

          var dotX = parseFloat(dot.style.left) / 100;
          var dotY = parseFloat(dot.style.top) / 100;
          var dCx = dotX * VW;
          var dCy = dotY * VH;

          var cardRect = card.getBoundingClientRect();
          var cW = cardRect.width;
          var cH = cardRect.height;
          var cLeft = parseFloat(card.style.left) / 100 * VW;
          var cTop = parseFloat(card.style.top) / 100 * VH;
          var cCx = cLeft + cW / 2;
          var cCy = cTop + cH / 2;

          var lineStyle = dot.dataset.lineStyle || 'straight';
          var inverseCurve = dot.dataset.inverseCurve === 'true';
          var NS = 'http://www.w3.org/2000/svg';

          if (lineStyle === 'straight') {
            var line = document.createElementNS(NS, 'line');
            line.setAttribute('x1', dCx);
            line.setAttribute('y1', dCy);
            line.setAttribute('x2', cCx);
            line.setAttribute('y2', cCy);
            if (isHideMobile) line.classList.add('custom-hero__svg-line--hide-mobile');
            svg.appendChild(line);
          } else {
            /* Curve: compute control point */
            var midX = (dCx + cCx) / 2;
            var midY = (dCy + cCy) / 2;
            var ddx = cCx - dCx;
            var ddy = cCy - dCy;
            var segLen = Math.sqrt(ddx * ddx + ddy * ddy);
            var nnx = -ddy / segLen;
            var nny = ddx / segLen;
            var sign = inverseCurve ? -1 : 1;
            var curvature = lineStyle === 'curve_soft' ? 0.2 : 0.4;
            var cpX = midX + sign * nnx * segLen * curvature;
            var cpY = midY + sign * nny * segLen * curvature;

            var pathEl = document.createElementNS(NS, 'path');
            pathEl.setAttribute('d', 'M ' + dCx + ' ' + dCy + ' Q ' + cpX + ' ' + cpY + ' ' + cCx + ' ' + cCy);
            pathEl.setAttribute('fill', 'none');
            pathEl.setAttribute('stroke', 'rgba(255, 255, 255, 0.65)');
            pathEl.setAttribute('stroke-width', '1.5');
            if (isHideMobile) pathEl.classList.add('custom-hero__svg-line--hide-mobile');
            svg.appendChild(pathEl);
          }
        });
      });
    }

    /* ── Lookbook: init markers ── */
    function initMarkers() {
      var hasMarkers = hero.querySelectorAll('.custom-hero__dot').length > 0;

      applyFocalPoints();

      if (hasMarkers) {
        applyMarkerPositions();
        setTimeout(function () {
          clampMobileCards();
          drawConnections();
        }, 100);
      }

      /* Only react to width changes — mobile browsers fire resize when
         the URL bar hides/shows (height-only change) and that would
         cause visible jitter if we re-laid-out every time.            */
      var lastWidth = window.innerWidth;
      var resizeTimer;
      window.addEventListener('resize', function () {
        var newWidth = window.innerWidth;
        if (newWidth === lastWidth) return;
        lastWidth = newWidth;
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          applyFocalPoints();
          if (hasMarkers) {
            applyMarkerPositions();
            clampMobileCards();
            drawConnections();
          }
        }, 150);
      });
    }

    /* ── Swiper slider ── */
    function initSwiper() {
      var swiperEl = hero.querySelector('.custom-hero__slider .swiper');
      if (!swiperEl) return;
      var slideCount = swiperEl.querySelectorAll('.swiper-slide').length;
      if (slideCount <= 1) {
        initMarkers();
        return;
      }

      var autoplay = hero.dataset.autoplay === 'true';
      var delay = (parseFloat(hero.dataset.delay) || 4) * 1000;
      var speed = (parseFloat(hero.dataset.speed) || 0.8) * 1000;
      var effect = hero.dataset.effect || 'fade';

      var config = {
        effect: effect,
        speed: speed,
        loop: true,
        fadeEffect: { crossFade: true },
        coverflowEffect: { rotate: 50, stretch: 0, depth: 100, modifier: 1, slideShadows: false },
        pagination: { el: hero.querySelector('.custom-hero__pagination'), clickable: true, type: 'bullets' }
      };
      if (autoplay) {
        config.autoplay = { delay: delay, disableOnInteraction: false, waitForTransition: true };
      }
      var sw = new Swiper(swiperEl, config);

      sw.on('slideChange', function () {
        hero.style.setProperty('--bullet-duration', (delay + speed) + 'ms');
      });

      initMarkers();
    }

    if (typeof Swiper !== 'undefined') {
      initSwiper();
    } else {
      document.addEventListener('DOMContentLoaded', initSwiper);
    }
  };
})();